import { render } from "./QuienesSomos.vue?vue&type=template&id=7acaa6c7"
import script from "./QuienesSomos.vue?vue&type=script&lang=js"
export * from "./QuienesSomos.vue?vue&type=script&lang=js"

import "./QuienesSomos.vue?vue&type=style&index=0&id=7acaa6c7&lang=css"

import exportComponent from "/var/www/html/frontend_ahdeco/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__